var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyVehicles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Vehicle Profile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Vehicles"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.59,18.08a1,1,0,0,0-.89-.62H44.14a1,1,0,0,0-.89.62,5.76,5.76,0,0,0-.31,1.26c-2-3.86-4.23-8.16-4.23-8.16A1.81,1.81,0,0,0,37.33,10a68.43,68.43,0,0,0-24.66,0,1.81,1.81,0,0,0-1.38,1.17s-2.22,4.3-4.23,8.16a5.76,5.76,0,0,0-.31-1.26,1,1,0,0,0-.89-.62H1.3a1,1,0,0,0-.89.62,4.49,4.49,0,0,0,0,3.45,1,1,0,0,0,.89.62H5.85c0,.05,0,.11,0,.17A2.33,2.33,0,0,0,4.2,24.55V40a1.13,1.13,0,0,0,1.13,1.12H11A1.12,1.12,0,0,0,12.1,40V37.27H13l2-4.73a.58.58,0,0,1,.55-.37h19a.58.58,0,0,1,.55.37L37,37.27h.92V40A1.12,1.12,0,0,0,39,41.11h5.65A1.13,1.13,0,0,0,45.8,40V24.55a2.33,2.33,0,0,0-1.66-2.23c0-.06,0-.12,0-.17H48.7a1,1,0,0,0,.89-.62A4.49,4.49,0,0,0,49.59,18.08ZM13.79,12.5s2.72-.68,11.21-.68,11.21.68,11.21.68l4,9.65H9.81ZM8.84,29.19V26H15.7l2,3.17Zm32.32,0h-8.9l2-3.17h6.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,37H16.72a1,1,0,1,1,0-2H33.31a1,1,0,0,1,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVehicles);
export default __webpack_public_path__ + "static/media/MyVehicles.74cc6856.svg";
export { ForwardRef as ReactComponent };